import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['video']

  initialize() {
    this.wistiaScriptUrl = 'https://fast.wistia.com/assets/external/E-v1.js'
    this.loaded = false

    if (this.hasVideoTarget) {
      this.setLoadOnScroll()
    }
  }

  loadWistiaScript() {
    var script = document.createElement('script')
    script.async = true
    script.src = this.wistiaScriptUrl

    script.onerror = function () {
      return new Error('Failed to load' + src)
    }

    script.onload = function () {}

    document.getElementsByTagName('head')[0].appendChild(script)
  }

  setLoadOnScroll() {
    if (!this.loaded) {
      document.addEventListener(
        'scroll',
        () => {
          this.loadWistiaScript()
        },
        { once: true }
      )
    }
    this.loaded = true
  }
}
